export default __webpack_public_path__ + "static/media/take-away (1).7afc92ac.png";